export const URL_PARAMETER_REGISTRATION_STATUS_TEXT = {
    id: `oe.accountAdmin.urlParameterRegistrationStatus`,
    message: 'URL Parameter Registration is {suffix}.',
    description: 'Label text'
};